import { Button } from '@pulse-web-ui/button';
import { media, mixins, styled, typography } from '@pulse-web-ui/theme';

export const SupportBlockContent = styled.div`
  box-sizing: border-box;
  padding-top: 40px;

  ${media.desktop} {
    padding-top: 32px;
  }
`;

export const SupportBlockTitle = styled.h3`
  ${typography.medium20};
  margin-bottom: 8px;

  ${media.desktop} {
    ${typography.medium24};
  }
`;

export const SupportBlockSubTitle = styled.div`
  ${typography.regular16};
  line-height: 24px;
  color: ${(props) => props.theme.colors.text.secondary};
  margin-bottom: 24px;

  ${media.desktop} {
    ${typography.regular18};
    line-height: 26px;
  }
`;

export const SupportButtonsWrapper = styled.div`
  ${mixins.flex({
    gap: 8,
    horizontal: false,
  })}

  ${media.desktop} {
    ${mixins.flex({ gap: 16 })}
  }
`;

export const SupportButton = styled(Button)`
  height: 48px;
  padding: 11px 30px;
`;
